import { formatCurrency } from '@ahm/common-helpers';
import { Badge, Box, Card, Group, Stack, Text, rem } from '@mantine/core';
import { unix } from 'dayjs';
import { PaymentMethodType } from 'node_modules/@ahm/api-wrappers-core/dist/api/payment/types';
import React from 'react';
import type { Transaction } from '@/api/payment/get-transactions-fn';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

type Props = {
  data: Transaction;
};

const getStatusBadgeProps = (status: string) => {
  const normalizedStatus = status.toLowerCase().replace(/\s+/g, '');
  switch (normalizedStatus) {
    case 'completed':
      return { color: '#1dc05e', bg: 'rgba(29, 192, 94, 0.05)' };
    case 'cancelled':
      return { color: '#ff3b30', bg: 'rgba(255, 59, 48, 0.05)' };
    case 'inprocess':
    case 'paying':
      return { color: '#007cff', bg: 'rgba(0, 124, 255, 0.1)' };
    case 'accepted':
      return { color: '#ff8200', bg: 'rgba(255, 130, 0, 0.1)' };
    default:
      return { color: '#1a1a1a', bg: 'rgba(26, 26, 26, 0.05)' };
  }
};

const SubscriptionHistoryItem = ({ data }: Props) => {
  const isMobile = useIsMobile();

  const getTransactionStatus = (amount: number) => {
    if (amount < 0) return { label: 'Thành công', key: 'completed' };
    if (amount > 0) return { label: 'Hoàn tiền', key: 'inprocess' };
    return { label: 'Thất bại', key: 'cancelled' };
  };

  const transactionTime = unix(data.time).format('DD/MM/YYYY, HH:mm');
  const status = getTransactionStatus(data.amount);
  const badgeStyle = getStatusBadgeProps(status.key);
  const amount = Math.abs(data.amount);

  return (
    <Card
      withBorder
      radius={rem(8)}
      p={isMobile ? rem(12) : rem(16)}
      style={{
        borderColor: 'var(--mantine-color-neutral-2)',
      }}
    >
      <Group align="stretch" wrap="nowrap">
        <Stack flex={1} gap={rem(4)} style={{ minWidth: 0 }}>
          <Text size={isMobile ? 'xs' : 'sm'} c="neutral.5" fw={500}>
            #{data.item_id}
          </Text>
          <Text
            size={isMobile ? 'sm' : 'md'}
            c="neutral.7"
            fw={500}
            lineClamp={1}
          >
            {data.note}
          </Text>
          <Text mt={6} size={isMobile ? 'xs' : 'sm'} c="neutral.5" fw={500}>
            {transactionTime}
          </Text>
        </Stack>

        <Box
          style={{
            width: isMobile ? rem(90) : rem(120),
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
          }}
        >
          <Badge
            radius={rem(12)}
            style={{
              textTransform: 'none',
              color: badgeStyle.color,
              backgroundColor: badgeStyle.bg,
            }}
          >
            {status.label}
          </Badge>

          <Text
            size={isMobile ? 'sm' : 'md'}
            c="neutral.7"
            fw={600}
            style={{ whiteSpace: 'nowrap' }}
          >
            {formatCurrency(amount)}
          </Text>
        </Box>
      </Group>
    </Card>
  );
};

export default SubscriptionHistoryItem;
